<template>
  <div class="container">
    <navbar />
    <div class="mainContent">
      <div class="showInfo">
        <h4 class="title">
          <span>&nbsp;&nbsp;客户信息</span>
        </h4>
        <div class="headContent">
          <el-row>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户姓名</span>
              <span>{{info.custName}}</span>
            </el-col>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户联系电话</span>
              <span>{{info.mobile}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户证件类型</span>
              <span>{{info.idType}}</span>
            </el-col>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户证件号码</span>
              <span>{{info.idNo}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户证件有效期（起期）</span>
              <span>{{info.cardStartDate}}</span>
            </el-col>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户证件有效期（止期）</span>
              <span>{{info.cardEndDate}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户更新有效期（起期）</span>
              <span>{{info.refresh_startDate}}</span>
            </el-col>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户更新有效期（止期）</span>
              <span>{{info.refresh_endDate}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11" :offset="1">
              <span class="labelName">客户更新时间</span>
              <span>{{info.finishDate}}</span>
            </el-col>
            <el-col :span="11" :offset="1"></el-col>
          </el-row>
        </div>
      </div>
      <div class="showInfo">
        <div class="content">
          <h4 class="contentTitle">
            <span>&nbsp;&nbsp;保单信息</span>
          </h4>
        </div>
        <div class="tableBottom">
          <el-table
            :data="contentInfos"
            border
            style="width:99%;margin:20px auto 0;"
            :max-height="tableHeight">
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="50"
              fixed
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="policyNo"
              label="保单号"
              width="165"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="appName"
              label="投保人姓名"
              width="165"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="appMobile"
              label="投保人联系电话"
              width="165">
            </el-table-column>
            <el-table-column
              align="center"
              prop="appAddress"
              label="投保人地址"
              width="120">
            </el-table-column>
            <el-table-column
              align="center"
              prop="agentCode"
              label="销售人员业务编码"
              width="165"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="agentName"
              label="销售人员姓名"
              width="165">
            </el-table-column>
            <el-table-column
              align="center"
              prop="orgStr"
              label="机构"
              width="165"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="custName"
              label="证件过期人"
              width="165"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="role"
              label="角色"
              width="165"
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="fixBtn">
        <el-button type="primary" @click="goback">返回</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogTableVisible" title="修改回复内容">
      <el-input resize="none"  type="textarea" :rows="2" placeholder="添加回复内容" v-model="replyContent"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clickCancel">取 消</el-button>
        <el-button type="primary" @click="submit">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 图片展示 -->
    <div class="dialogWh">
      <el-dialog :visible.sync="showImg" v-if="show">
        <div v-for="item in imgs" :key="item" class="dialogImg">
          <img v-image-preview :src="item"/>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import vHeader from '@/layout/Header.vue'
import Navbar from "@/modules/Navbar";
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  name:'OperationDetail',
  data(){
    return {
      dataCollect:{},
      contentInfos:[],
      dialogTableVisible:false,
      showImg:false,
      imgs:[], //照片容器
      show:false,
      replyContent:'',
      imgsCollect:[],
      tableHeight: "100%",
      info: {
        custName: '',
        mobile: '',
        idType: '',
        idNo: '',
        cardStartDate: '',
        cardEndDate: '',
        refresh_startDate: '',
        refresh_endDate: '',
        finishDate: '',
      }
    }
  },
  components: {
    Navbar
  },
  methods:{
    getConsultDetailPC(){
      if(sessionStorage.getItem('consultNo')){
        this.consultNo = JSON.parse(decodeURIComponent(sessionStorage.getItem('consultNo')))
      }
      this.contentInfos = []
      let param = {
        custNo:this.consultNo
      }
      api.post(url.queryCustomerDetails, param, res=> {
        console.log("res====",res)
        if(res.result.isSuccess){
          this.info.custName = res.data.custName
          this.info.idType = res.data.idType
          this.info.idNo = res.data.idNo
          this.info.mobile = res.data.mobile
          this.info.cardStartDate = res.data.cardStartDate && res.data.cardStartDate.length == 8 ? res.data.cardStartDate.slice(0,4) + '-' + res.data.cardStartDate.slice(4,6) + '-' + res.data.cardStartDate.slice(6,) : '——'
          this.info.cardEndDate = res.data.cardEndDate && res.data.cardEndDate.length == 8 ? res.data.cardEndDate.slice(0,4) + '-' + res.data.cardEndDate.slice(4,6) + '-' + res.data.cardEndDate.slice(6,) : '——'
          this.info.refresh_startDate = res.data.newStartDate ? this.changeDate(res.data.newStartDate) : '——'
          this.info.refresh_endDate = res.data.newEndDate ? this.changeDate(res.data.newEndDate) : '——'
          this.info.finishDate = res.data.finishDate ? this.changeDate(res.data.finishDate) : '——'
          res.data.policyDetailsRepVos.forEach((item) => {
            item.orgStr = item.t2Name + (item.t2Name.indexOf(item.t3Name) > -1 ? '':item.t3Name) + item.t4Name
            // item['agentCode'] = res.data.agentCode
            // item['agentName'] = res.data.agentName
            item['custName'] = res.data.custName
            this.contentInfos.push(item)
          })
        }
      });
    },
    handleImg(val){
      // console.log(val,'ddd')
      this.showImg = true
      this.show = true
      this.imgs = val.images
    },
    updateReply(row){
      this.dialogTableVisible = true
      this.contentId = row.contentId
    },
    submit(){
      let params ={
        contentId:this.contentId,
        replyContent:this.replyContent,
      }
      if(!this.replyContent){
        this.$message.error('请输入回复内容')
        return false
      }
      api.post(url.modifyReply, params, res=> {
        if(res.result.isSuccess){
          this.getConsultDetailPC()
          this.dialogTableVisible = false
          this.replyContent = ''
        }else{
          
        }
      });
    },
    clickCancel(){
      this.dialogTableVisible = false
      this.replyContent = ''
    },
    goback(){
      let getList = this.$route.params.getNochange
      let req = this.$route.params.getList
      let customerName = this.$route.params.customerName
      let applyName = this.$route.params.applyName
      let applyCode = this.$route.params.applyCode
      let idNo = this.$route.params.idNo
      let dateStart = this.$route.params.dateStart
      this.$router.push({
        name:'checkCard1',
        params:{
          req,
          customerName,
          applyName,
          applyCode,
          getList,
          dateStart,
          idNo,
        }
      })
    },
    changeDate (dateTime) {
      var date = new Date(dateTime)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minutes = date.getMinutes()
      var second = date.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if(hour < 10) {
        hour = '0' + hour
      }
      if(minutes < 10) {
        minutes = '0' + minutes
      }
      if(second < 10) {
        second = '0' + second
      }
      var time = year + '-' + month + '-' + day
      return time
    },
    getTableHeight() {
      this.tableHeight = (document.querySelector(".tableBottom").clientHeight) * 5;
    },
  },
  mounted(){
    this.getConsultDetailPC()
    this.$nextTick(() => {
      this.getTableHeight();
    })
  },
}
</script>
<style scoped>
.title {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0;
}
.headContent{
  padding: 20px 20px 20px 20px;
  line-height: 55px;
  background: #fff;
}
.headContent >>> .el-row{
  height: 55px;
}
.img >>> .el-row{
  line-height: 55px;
}
.img >>> .el-col-18{
  margin-top:15px;
}
.content{
  background: #fff;
}
.contentTitle{
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0;
}
.contentTip{
  padding: 10px 0 10px 100px;
}
.contentTip p{
  font-size: 13px;
}
.contentTip p>span{
  display: inline;
  margin-right: 10px;
}
.container {
  background: #fff;
  height: 100%;
}
.container >>> .el-dialog{
  width: 400px;
  height: 300px;
}
.container >>> .el-textarea__inner{
  height: 150px;
}
.container >>> .el-dialog__footer{
  width: 100%;
  display: flex;
  justify-content:space-around;
}
.container >>>  .el-dialog__body{
  padding:10px 20px;
}
.tableBottom{
  background: #fff;
}
.dialogImg {
  display: inline-block;
}
.dialogImg img{
  margin-right: 10px;
  width: 100px;height: auto;
}
.dialogWh{
  background: #fff;
}
.dialogWh >>> .el-dialog {
  z-index:2000;
  width: 600px;min-height:400px;
  height:auto;
}
.fixBtn{
  width: 90%;
  margin: 20px auto;
  text-align: right;
}
</style>
<style>
body /deep/ .vue-directive-image-previewer{
  z-index: 10000;
}
body /deep/ .vue-directive-image-previewer-body{
  z-index: 3000;
}
body /deep/ .vue-directive-image-previewer-body img{
  z-index: 3000;
}
.showInfo {
  width: 90%;
  border: 1px solid #eee;
  margin: 20px auto;
}
.labelName {
  width: 40%;
  display: inline-block;
}
.mainContent {
  height: calc(100% - 65px);
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/checkCard/detail.vue